const ON_CHANGE_DEBOUNCE_TIMER = 300;

// How long a capped-quantity notice stays on a cart line before it clears.
const LINE_ITEM_NOTICE_TIMEOUT = 8000;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
